import { ProjectType, ProjectTypes } from "../../../common/constants";
import api from "../../../components/api";

export type EstimateDetailedCloseData = {
  projectId: number;
  estimateId: number;
  timestamp: string;
  approveDateUtc: string;
  daysToClose: number;
  divisionName: string;
  salesPersonEmail: string;
  salesPersonName: string;
  jobType: ProjectType;
}

export type EstimateDetailedTurnaroundData = {
  projectId: number;
  estimateId: number;
  initiateDateUtc: string;
  timestamp: string;
  estimateTurnaround: number;
  divisionName: string;
  salesPersonEmail: string;
  salesPersonName: string;
  jobType: ProjectType;
}

export type EstimateReport = {
  groupedEstimatesData: EstimatesSummary,
  detailedDaysToCloseData: EstimateDetailedCloseData[],
  detailedTurnaroundData: EstimateDetailedTurnaroundData[]
}

export type EstimateTurnaroundData = {
  totalEstimateTurnaroundDays: number
  estimateTotal: number
  estimateTurnaround: number
}

export type DaysToCloseData = {
  totalDaysToClose: number
  estimateTotal: number
  daysToClose: number
}

export type EstimatesSummary = {
  [key: string]: any;
  approved: EstimateReportData[],
  sent: EstimateReportData[],
  lost: EstimateReportData[],
  unsent: EstimateReportData[]
}

export type EstimateReportData = {
  projectId: number,
  jobName: string,
  jobType: ProjectType,
  jobNo: string,
  estimateDateUtc: string,
  jobTypeName?: string,
  price: number,
  customerId: number,
  displayName: string,
  propertyId: number,
  address1: string,
  city: string,
  state: string,
  zip: number,
  salesPersonName: string,
  property?: string,
  isSold: boolean,
  divisions: string,
  archivedAtUtc?: string | null
};

export const defaultEstimateReportData = (): EstimateReportData => ({
  projectId: 1, jobName: 'Patio', jobType: ProjectTypes.Project, jobNo: 'J-1', estimateDateUtc: '2026-10-01T12:00:00Z',
  price: 150000, customerId: 1, displayName: 'Jane Doe', propertyId: 1, address1: '1 Main St', city: 'Austin',
  state: 'TX', zip: 78701, salesPersonName: 'Owen Owner', isSold: false, divisions: '', archivedAtUtc: null,
})


export const getEstimatesReportData = async (startDate?: string, endDate?: string): Promise<EstimateReport> => {
  return (await api.get(`/web/datacenter/estimates/${startDate}/${endDate}`)).data
}
